/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import { ErrorBoundary } from './components/ErrorBoundary'
import { WebsiteAnalyticsHeader } from './components/WebsiteAnalyticsHeader'
import { WebsiteAnalyticsDashboard } from './components/WebsiteAnalyticsDashboard'

const DashboardPage: FC = () => (
  <div className="pb-10">
    {/* Website Analytics Dashboard */}
    <WebsiteAnalyticsHeader />
    <WebsiteAnalyticsDashboard />
  </div>
)

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <ErrorBoundary>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <DashboardPage />
    </ErrorBoundary>
  )
}

export {DashboardWrapper}
